import merge from 'lodash/merge'
import { toDate } from '@ztechapps/common.utils'
import { DateTimeZoneWidget } from './Widgets/DateTimeZone'
import { dateTimeZoneOptions } from './dateTimeZoneOptions'
import { BasicConfig } from 'react-awesome-query-builder'
import { positiveCountOptionToFilter } from '../DataTable/table-filter/positiveCountFilter.utils'

const defaultConfig = {
  ...BasicConfig,
}

export const useConfig = ({ config, timeZone }) => {
  const newConfig = merge({}, defaultConfig, config, {
    //the Unread/Read choice of a `positiveCountSelect` field: a plain select whose saved condition is the shared filter
    operators: {
      positive_count_equals: {
        label: 'is',
        labelForFormat: 'is',
        cardinality: 1,
        mongoFormatOp: (field, _op, value) => ({ [field]: positiveCountOptionToFilter(value) }),
      },
    },
    types: {
      positiveCountSelect: {
        mainWidget: 'select',
        defaultOperator: 'positive_count_equals',
        widgets: {
          select: {
            operators: ['positive_count_equals'],
          },
        },
      },
      dateTimeZone: {
        ...defaultConfig?.types?.datetime,
        widgets: {
          dateTimeZone: {
            ...defaultConfig?.types?.datetime?.widgets?.datetime,
            widgetProps: {
              options: dateTimeZoneOptions,
            },
          },
        },
      },
    },
    widgets: {
      dateTimeZone: {
        type: 'dateTimeZone',
        valueSrc: 'value',
        mongoFormatValue: (val) => {
          const isDynamic = val?.indexOf?.('<<') !== -1
          if (isDynamic) return val
          else {
            const dateVal = toDate(val, timeZone)
            const result = dateVal.isValid() ? dateVal?.toDate() : val
            return result
          }
        },
        factory: DateTimeZoneWidget,
      },
    },
  })

  return { newConfig }
}
